"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountGradeList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const components_1 = require("@rws-framework/components");
const component_1 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="mb-4 d-flex justify-content-between align-items-center">
                <div>
                    <button @click="${x => x.goBack()}" class="btn btn-outline-secondary btn-sm mr-3">
                        <i class="simple-icon-arrow-left"></i> ${'common.back'.t()}
                    </button>
                </div>
            </div>

            <crud-table 
                resource="accountGrade"
                title="accountGrade.list.title"
                listEndpoint="accountGrade.list"
                deleteEndpoint="accountGrade.delete"
                addRoute="/settings/account-grade/form"
                editRoute="/settings/account-grade/form/:id"
                previewRoute="/settings/account-grade/preview/:id"
                addText="accountGrade.add"
                showPagination="false"
                emptyMessage="accountGrade.noResults"
                :columns="${x => x.tableColumns}"
                :actions="${x => x.baseActions}"
                :onDataLoaded="${x => x.onDataLoaded.bind(x)}"
                >
                <div slot="extra-buttons">
                    <button type="button" class="btn btn-outline-secondary mr-2" @click="${x => x.showOrderingModal.bind(x)()}">
                        <i class="fas fa-layer-group"></i> ${'common.ordering'.t()}
                    </button>         
                </div>
            </crud-table>            
        </div>
    </div>
</div>
${(0, fast_element_1.when)(x => x.orderingShown, (0, fast_element_1.html) `<rws-modal header="${'common.ordering'.t()}" ${(0, fast_element_1.ref)('sortingModal')} maxWidth="300px" :onShowModal="${x => x.onShowModal.bind(x)}" :closeModal="${x => x.closeOrderingModal.bind(x)}" name="accountGrade.ordering">
    <div ${(0, fast_element_1.ref)('sortingContainer')} id="ac-ordering">
        ${(0, fast_element_1.repeat)(x => x.accountGrades, grade => (0, fast_element_1.html) `<div class="ordering-item card" data-id="${grade => grade.id}" data-order="${grade => grade.order || 0}">
            <div class="card-header d-flex justify-content-between align-items-center">
                <span>${grade => grade.name}</span>
                <i class="fas fa-grip-vertical text-muted" style="cursor: grab;"></i>
            </div>
        </div>`)}
    </div>
</rws-modal>`)}`;
require("./styles/layout.scss");
const styles = T.css `#ac-ordering {
  min-height: 200px;
  padding: 10px;
}
#ac-ordering[dragstate=drag-over] {
  background-color: #f0f0f0;
  border: 2px dashed #007bff;
  border-radius: 8px;
}
#ac-ordering .ordering-item {
  margin-bottom: 8px;
  transition: all 0.2s ease;
  cursor: move;
}
#ac-ordering .ordering-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
#ac-ordering .ordering-item[dragstate=dragging] {
  opacity: 0.7;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  border: 2px solid #007bff;
  background-color: rgba(0, 123, 255, 0.05);
}
#ac-ordering .ordering-item.drag-over {
  border-top: 3px solid #007bff;
  margin-top: 8px;
}
#ac-ordering .ordering-item[sortstate=move-up] {
  transform: translateY(-50px);
  transition: transform 0.2s ease;
  opacity: 0.8;
}
#ac-ordering .ordering-item[sortstate=move-down] {
  transform: translateY(50px);
  transition: transform 0.2s ease;
  opacity: 0.8;
}
#ac-ordering .ordering-item[sortstate=drop-target] {
  position: relative;
}
#ac-ordering .ordering-item[sortstate=drop-target]::after {
  content: "";
  position: absolute;
  top: -4px;
  left: 0;
  right: 0;
  height: 4px;
  background-color: #28a745;
  border-radius: 2px;
  box-shadow: 0 0 8px rgba(40, 167, 69, 0.6);
  z-index: 10;
}
#ac-ordering .ordering-item.drag-placeholder {
  opacity: 0.5;
  background-color: #e9ecef;
  border: 2px dashed #6c757d;
}
#ac-ordering .ordering-item.drag-placeholder .card-header {
  background-color: transparent;
}
#ac-ordering .ordering-item .card-header {
  background-color: #f8f9fa;
  padding: 12px 16px;
}
#ac-ordering .ordering-item .card-header .fa-grip-vertical {
  font-size: 14px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}
#ac-ordering .ordering-item .card-header .fa-grip-vertical:hover {
  opacity: 1;
}
#ac-ordering .ordering-item[sortstate=gap-above] {
  margin-top: 58px;
  position: relative;
}
#ac-ordering .ordering-item[sortstate=gap-above]::before {
  content: "Drop here";
  position: absolute;
  top: -54px;
  left: 0;
  right: 0;
  height: 50px;
  background-color: rgba(40, 167, 69, 0.1);
  border: 2px dashed #28a745;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #28a745;
  font-weight: bold;
  font-size: 14px;
  z-index: 5;
}
#ac-ordering .ordering-item[sortstate=gap-below] {
  margin-bottom: 58px;
  position: relative;
}
#ac-ordering .ordering-item[sortstate=gap-below]::after {
  content: "Drop here";
  position: absolute;
  bottom: -54px;
  left: 0;
  right: 0;
  height: 50px;
  background-color: rgba(40, 167, 69, 0.1);
  border: 2px dashed #28a745;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #28a745;
  font-weight: bold;
  font-size: 14px;
  z-index: 5;
}`;
const shadowOptions = { "mode": "open" };
let AccountGradeList = class AccountGradeList extends client_1.RWSViewComponent {
    constructor(dragDropService) {
        super();
        this.dragDropService = dragDropService;
        this.tableColumns = [
            {
                key: 'name',
                header: 'accountGrade.name'.t()
            },
            {
                key: 'price',
                header: 'accountGrade.price'.t(),
                formatter: (value, row) => {
                    if (value === null || value === undefined) {
                        return 'common.free'.t();
                    }
                    return `$${value.toFixed(2)}`;
                }
            },
            {
                key: 'creditsPerMonth',
                header: 'accountGrade.creditsPerMonth'.t(),
                formatter: (value, row) => {
                    if (value === null || value === undefined || value === 0) {
                        return '<span class="text-muted">-</span>';
                    }
                    return `<span class="badge badge-info">${value.toLocaleString()} credits</span>`;
                }
            },
            {
                key: 'limits',
                header: 'accountGrade.limits'.t(),
                formatter: (value, row) => {
                    const limits = [];
                    if (row.maxUsers !== null && row.maxUsers !== undefined) {
                        limits.push(`<span class="badge badge-info mr-1">${'accountGrade.maxUsers'.t()}: ${row.maxUsers}</span>`);
                    }
                    else {
                        limits.push(`<span class="badge badge-success mr-1">${'accountGrade.maxUsers'.t()}: ${'accountGrade.unlimited'.t()}</span>`);
                    }
                    if (row.maxAvatars !== null && row.maxAvatars !== undefined) {
                        limits.push(`<span class="badge badge-info mr-1">${'accountGrade.maxAvatars'.t()}: ${row.maxAvatars}</span>`);
                    }
                    else {
                        limits.push(`<span class="badge badge-success mr-1">${'accountGrade.maxAvatars'.t()}: ${'accountGrade.unlimited'.t()}</span>`);
                    }
                    if (row.maxProjectsCount !== null && row.maxProjectsCount !== undefined) {
                        limits.push(`<span class="badge badge-info mr-1">${'accountGrade.maxProjectsCount'.t()}: ${row.maxProjectsCount}</span>`);
                    }
                    else {
                        limits.push(`<span class="badge badge-success mr-1">${'accountGrade.maxProjectsCount'.t()}: ${'accountGrade.unlimited'.t()}</span>`);
                    }
                    if (row.maxKnowledgeEntries !== null && row.maxKnowledgeEntries !== undefined) {
                        limits.push(`<span class="badge badge-info mr-1">${'accountGrade.maxKnowledgeEntries'.t()}: ${row.maxKnowledgeEntries}</span>`);
                    }
                    else {
                        limits.push(`<span class="badge badge-success mr-1">${'accountGrade.maxKnowledgeEntries'.t()}: ${'accountGrade.unlimited'.t()}</span>`);
                    }
                    if (row.customAiModels !== null && row.customAiModels !== undefined) {
                        limits.push(`<span class="badge badge-info mr-1">${'accountGrade.customAiModels'.t()}: ${row.customAiModels}</span>`);
                    }
                    else {
                        limits.push(`<span class="badge badge-success mr-1">${'accountGrade.customAiModels'.t()}: ${'accountGrade.unlimited'.t()}</span>`);
                    }
                    return limits.join('<br>');
                }
            },
            {
                key: 'features',
                header: 'accountGrade.features'.t(),
                formatter: (value, row) => {
                    const features = [];
                    if (row.advancedPrompts)
                        features.push(`<span class="badge badge-primary mr-1">${'accountGrade.advancedPrompts'.t()}</span>`);
                    if (row.promptAssist)
                        features.push(`<span class="badge badge-primary mr-1">${'accountGrade.promptAssist'.t()}</span>`);
                    if (row.antiHallucination)
                        features.push(`<span class="badge badge-primary mr-1">${'accountGrade.antiHallucination'.t()}</span>`);
                    if (row.advancedReports)
                        features.push(`<span class="badge badge-primary mr-1">${'accountGrade.advancedReports'.t()}</span>`);
                    if (row.chatThreadSharing)
                        features.push(`<span class="badge badge-primary mr-1">${'accountGrade.chatThreadSharing'.t()}</span>`);
                    if (row.customBranding)
                        features.push(`<span class="badge badge-primary mr-1">${'accountGrade.customBranding'.t()}</span>`);
                    if (row.widgets)
                        features.push(`<span class="badge badge-primary mr-1">${'accountGrade.widgets'.t()}</span>`);
                    if (row.voiceAgent)
                        features.push(`<span class="badge badge-primary mr-1">${'accountGrade.voiceAgent'.t()}</span>`);
                    if (row.writingStyles)
                        features.push(`<span class="badge badge-primary mr-1">${'accountGrade.writingStyles'.t()}</span>`);
                    return features.length > 0 ? features.join(' ') : '-';
                }
            },
            {
                key: 'active',
                header: 'accountGrade.active'.t(),
                formatter: (value, row) => {
                    const status = value ? 'common.active'.t() : 'common.inactive'.t();
                    const badgeClass = value ? 'success' : 'danger';
                    return `<span class="badge badge-${badgeClass}">${status}</span>`;
                }
            }
        ];
        this.baseActions = [];
        this.accountGrades = [];
        this.orderingShown = false;
        this.sortingAssigned = false;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    onShowModal(dom) {
        this.setupDragDrop();
    }
    async onDataLoaded(data) {
        this.accountGrades = data;
    }
    setupDragDrop() {
        if (this.sortingAssigned) {
            return;
        }
        const dragItems = [];
        this.sortingContainer.querySelectorAll('.ordering-item').forEach(el => {
            dragItems.push(el);
        });
        if (dragItems.length) {
            for (const dragItem of dragItems) {
                this.dragDropService.drag(dragItem, this, {
                    getDragElementData: (element) => {
                        const id = element.getAttribute('data-id') || '';
                        const order = parseInt(element.getAttribute('data-order') || '0');
                        return {
                            element: dragItem,
                            type: 'sortable-item',
                            data: {
                                id,
                                order
                            }
                        };
                    },
                    dragElementType: 'sortable-item',
                    sortable: true,
                    onDropOut: (dropOutData) => {
                        console.log('Dropped out:', dropOutData);
                    }
                });
            }
        }
        const tabsContainer = this.sortingContainer;
        if (tabsContainer) {
            this.dragDropService.drop(tabsContainer, ['sortable-item'], (dropData, dropZone, event) => {
                // The service now provides sortingOrder and originalOrder automatically
                const newSortingOrder = dropData.sortingOrder || dropData.data.order;
                const originalOrder = dropData.originalOrder || dropData.data.order;
                this.updateAllItemsOrder(dropData.allItemsOrder || []);
                this.sendSorting(dropData.allItemsOrder);
            }, this, { sortable: true });
        }
        this.sortingAssigned = true;
    }
    async sendSorting(allItemsOrder) {
        if (!allItemsOrder) {
            console.error('All items order is undefined.');
            return;
        }
        try {
            await this.apiService.back.post('accountGrade.sort', {
                sort: allItemsOrder.reduce((acc, item) => {
                    acc[item.id] = item.order;
                    return acc;
                }, {})
            });
            this.$('crud-table').loadData();
        }
        catch (error) {
            console.error('Error sending sorting:', error);
        }
    }
    showOrderingModal() {
        this.orderingShown = true;
    }
    closeOrderingModal() {
        this.orderingShown = false;
    }
    /**
     * Update all items order based on DOM order (0-based)
     */
    updateAllItemsOrder(allItemsOrder) {
        // Create a new array to trigger observable change
        const updatedGrades = [...this.accountGrades];
        // Update order for all items based on DOM position
        allItemsOrder.forEach(item => {
            const grade = updatedGrades.find(g => g.id.toString() === item.id);
            if (grade) {
                grade.order = item.order; // This will be 0-based from DOM position
            }
        });
        // Sort the array by new order and assign to trigger re-render
        this.accountGrades = updatedGrades.sort((a, b) => (a.order || 0) - (b.order || 0));
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/settings');
    }
};
exports.AccountGradeList = AccountGradeList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AccountGradeList.prototype, "tableColumns", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AccountGradeList.prototype, "baseActions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AccountGradeList.prototype, "accountGrades", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AccountGradeList.prototype, "orderingShown", void 0);
exports.AccountGradeList = AccountGradeList = __decorate([
    (0, client_1.RWSView)('account-grade-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(components_1.DragDropService)),
    __metadata("design:paramtypes", [typeof (_a = typeof components_1.DragDropServiceInstance !== "undefined" && components_1.DragDropServiceInstance) === "function" ? _a : Object])
], AccountGradeList);
AccountGradeList.defineComponent();
